import React from 'react';
import PropTypes from 'prop-types';

import { Container, IDesc } from './common/styles';
import OptionsControl from './options-control';
import { updateNotifyOnComment } from '../../../services/profiles/notification-settings-service';

export default function CommentOptionsControl(props) {
  return (
    <Container>
      <IDesc>
        When someone comments on my wire
      </IDesc>
      <OptionsControl
        id="comment-options"
        options={props.options}
        updateOptionsFunction={updateNotifyOnComment}
      />
    </Container>
  );
}

CommentOptionsControl.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};
